import { AutoSelectOptions } from '../components/AutoSelectModal';

const AUTO_SELECT_SETTINGS_KEY = 'talkoot_auto_select_settings';

export interface SavedAutoSelectSettings {
  productIds?: string[];
  intentCategories?: string[];
  strategy?: 'top-volume-only' | 'top-n-per-intent';
  topN?: number;
  intentTopN?: Record<string, number>;
}

/**
 * Load saved auto-select settings from localStorage
 */
export function loadAutoSelectSettings(): SavedAutoSelectSettings | null {
  try {
    const saved = localStorage.getItem(AUTO_SELECT_SETTINGS_KEY);
    if (saved) {
      return JSON.parse(saved);
    }
  } catch (error) {
    console.error('Error loading auto-select settings:', error);
  }
  return null;
}

/**
 * Save auto-select settings to localStorage
 */
export function saveAutoSelectSettings(options: AutoSelectOptions): void {
  try {
    const settings: SavedAutoSelectSettings = {
      productIds: options.productIds,
      intentCategories: options.intentCategories,
      strategy: options.strategy,
      topN: options.topN,
      intentTopN: options.intentTopN
    };
    localStorage.setItem(AUTO_SELECT_SETTINGS_KEY, JSON.stringify(settings));
  } catch (error) {
    console.error('Error saving auto-select settings:', error);
  }
}

